export const imageSize = {
    width: "560px",
    height: "315px"
};
